// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { ModalType } from 'containers/ModalRoot';

type ShowModalAction = {
  type: 'MODAL_SHOW';
  payload: {
    type: string;
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    props: Record<string, any>;
  };
};
type HideModalAction = {
  type: 'MODAL_HIDE';
};
export type Action = ShowModalAction | HideModalAction;
export const showModal = (
  type: ModalType,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  props: Record<string, any> = {}
): ShowModalAction => ({
  type: 'MODAL_SHOW',
  payload: {
    type,
    props,
  },
});
export const hideModal = (): HideModalAction => ({
  type: 'MODAL_HIDE',
});
